var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{class:_vm.toggleClass,attrs:{"size":_vm.size,"type":_vm.type},on:{"click":function($event){$event.preventDefault();return _vm.toggle()}}},[(_vm.toggleIcon)?_c('i',{staticClass:"toggle-icon",class:_vm.iconClass}):_vm._e(),_vm._v(" "),(_vm.toggleText)?_c('span',{class:{
			'toggle-text-only' : !_vm.toggleIcon,
			'toggle-text hidden sm:inline-block' : _vm.type === 'text'
		}},[_vm._v(_vm._s(_vm.toggleText))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }